<template>
  <router-view />
</template>

<script>
export default {
  name: "Requests"
}
</script>

<style scoped>

</style>